import { add } from 'date-fns'
import { setCookie } from 'cookies-next'
import { useCallback } from 'react'
import { getCurrentDomain } from 'lib/helpers/getCurrentDomain/getCurrentDomain'
import { cookieKeys } from 'lib/consts/browserStorage'

type Options = Parameters<typeof setCookie>[2]

export const useSetDeviceTokenCookie = () =>
  useCallback((deviceToken: string, options?: Options) => {
    const o: Options = {
      ...options,
      expires: add(new Date(), { days: 30 }),
    }

    if (process.env.REDIRECT_TO_BRAND) {
      o.domain = getCurrentDomain()
      o.path = '/'
    }

    setCookie(cookieKeys.deviceToken, deviceToken, o)
  }, [])
